/** Shared Kanban / list card title: "Person - Company". */

export function personCompanyTitle(
  person: string | null | undefined,
  company: string | null | undefined,
  fallback = "Untitled",
): string {
  const who = (person ?? "").trim();
  const org = (company ?? "").trim();
  if (who && org && who.toLowerCase() !== org.toLowerCase()) return `${who} - ${org}`;
  return who || org || fallback;
}

export function leadPersonName(lead: {
  first_name?: string | null;
  last_name?: string | null;
}): string {
  return `${lead.first_name ?? ""} ${lead.last_name ?? ""}`.trim();
}

export function opportunityPersonName(opp: {
  primary_contact_name?: string | null;
  source_lead_name?: string | null;
}): string {
  return (opp.primary_contact_name ?? "").trim() || (opp.source_lead_name ?? "").trim();
}
